import { getApiHealth } from '@/lib';
import { ApiHealthCheckResponse } from '@/types/api';

/**
 * Loads the API health check status.
 */
export const loadApiHealthCheck = async (): Promise<ApiHealthCheckResponse> => {
  return getApiHealth();
};
